import React from "react";
import { valueToString } from "helpers/Helpers";
import classNames from "classnames";
import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function TicketsExpiredTable(props: IProps) {

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string) {
    return formatDisplay(displayType, cellValue);
  }

  // Add on click events based on column
  function cellOnClick(cell: any) {
    if (!cell) {
      return null;
    }
    switch (cell.column.id) {
      case "code":
        return cell.row.original.stub_id
          ? window.open(`/admin/tickets/stubs/${String(cell.row.original.stub_id)}`)
          : null;
      default:
        return null;
    }
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
      "report-table-cell-clickable": cell.column.id === "code",
    });
  }

  // Add footer data based on column
  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }

    switch (columnId) {
      case "title":
        return footerRow?.title as string;

      default:
        return footerRow[columnId] as string ?? null;
    }
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={false}
    />
  );
}
